import { render, staticRenderFns } from "./ComprobanteACobrar.vue?vue&type=template&id=4c583106&"
import script from "./ComprobanteACobrar.vue?vue&type=script&lang=js&"
export * from "./ComprobanteACobrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports